import React from "react";
function Payment () {
    return (

        <h2>Payment</h2>
    )
    
}
export default Payment;